import { observer } from 'mobx-react-lite'
import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { __product } from './__product'
import { Row, Col, Radio, Divider } from 'antd'
import i from '../../../translations/i'
import { Titles } from '../../../layouts/Titles'
import { ProductMain } from './product_modules/ProductMain'
import { ProductImages } from './product_modules/ProductImages'
import { ProductMarketing } from './product_modules/ProductMarketing'
import { ProductProps } from './product_modules/ProductProps'
import { ProductWith } from './product_modules/ProductWith'
import { ProductWarehouses } from './product_modules/ProductWarehouses'
import { ProductFiles } from './product_modules/ProductFiles'
import { ProductText } from "./product_modules/ProductText"
import { ProductSet } from "./product_modules/ProductSet";
import { storeLocal } from "../../../helpers/stores";
import { canManageOwnedRecord } from "../../../helpers/manager_ownership";
import { ProductPrice } from "./product_modules/ProductPrice";
import price_types_controller from "../../settings/price_types/controller";
import { ProductLinksToProducts } from "./product_modules/ProductLinksToProducts";
import { ProductModifiers } from "./product_modules/ProductModifiers";
import { ProductSplitPayments } from "./product_modules/ProductSplitPayments";

export const Product = observer(() => {

    const { productID, categoryID }: any = useParams()

    const isFranchisee = storeLocal.get('role') === 6
    const isNewProduct = !__product.item.id || __product.item.id === 0
    // Франчайзи редактирует все поля при создании товара и при правке своего - блокируем
    // только чужой существующий товар (там доступны лишь цена/остаток по своим складам,
    // см. ProductWarehouses и бэкенд updateFranchiseeWarehousePrices()).
    const fieldsDisabled = isFranchisee && !isNewProduct && !canManageOwnedRecord(__product.item)

    useEffect(() => {
        if(productID > 0) {
          __product.getOne(productID)
        }
        if(categoryID > 0) __product.item.categories.push(categoryID)
      price_types_controller.get()
    }, [])

    return(
        <>
            <form onSubmit={(e) => __product.sendForm(e)}>
                <Titles
                    title={`${i.t('product:editProduct')}:\n${__product.item.name}`}
                    buttons={__product.item.product_id > 0 ? [
                      { title: i.t('product:back'), href: `/shop/catalog/product/${__product.item.product_id}` },
                      { title: i.t('def:actions.save'), htmlType: 'submit', type: 'primary' },
                    ] : [
                        { title: i.t('def:actions.save'), htmlType: 'submit', type: 'primary' },
                    ]}
                />
                <Row gutter={[20, 20]}>
                    <Col span={24}>
                        <Radio.Group
                            className="product-tabs-radio"
                            optionType="button"
                            buttonStyle="solid"
                            value={__product.item_tab}
                            onChange={(e) => __product.changeTab(e.target.value)}
                            options={[
                                { label: i.t('product:tabMain'), value: 'main' },
                                { label: i.t('product:text'), value: 'text' },
                                { label: i.t('product:tabImage'), value: 'images' },
                                { label: i.t('product:tabProps'), value: 'props', disabled: !__product.item.id || __product.item.id === 0 },
                                { label: i.t('product:forWiths'), value: 'with' },
                                { label: i.t('nav:modifiers'), value: 'modifiers', disabled: !__product.item.id || __product.item.id === 0 },
                                { label: i.t('product:tabMarketing'), value: 'marketing' },
                                { label: i.t('product:storage'), value: 'warehouses' },
                                { label: i.t('def:Files'), value: 'files' },
                                { label: i.t('def:Product set'), value: 'set', disabled: storeLocal.get('pricing_plan') < 1 || storeLocal.get('black_mark') },
                                { label: i.t('def:Product prices'), value: 'price', disabled: storeLocal.get('pricing_plan') < 2 || storeLocal.get('black_mark') || price_types_controller.items.length === 0 },
                                { label: i.t('product:linkedProductsTab'), value: 'links', disabled: storeLocal.get('pricing_plan') < 2 || storeLocal.get('black_mark') },
                                { label: i.t('paymentOptions:splitPayments'), value: 'split_payments', disabled: !__product.item.id || __product.item.id === 0 }
                            ]}
                        />
                    </Col>
                    <Col span={24}>
                        <Divider />
                    </Col>
                  {((productID > 0 && __product.item.id > 0) || (!productID || __product.item.id === 0))
                    ? <>
                      <Col span={24}>
                        {__product.item_tab === 'warehouses'
                          ? <ProductWarehouses />
                          : <fieldset disabled={fieldsDisabled} style={fieldsDisabled ? { border: 'none', padding: 0, margin: 0, opacity: 0.6 } : undefined}>
                              {__product.item_tab === 'main' ? <ProductMain /> : <></>}
                              {__product.item_tab === 'text' ? <ProductText /> : <></>}
                              {__product.item_tab === 'images' ? <ProductImages /> : <></>}
                              {__product.item_tab === 'props' ? <ProductProps /> : <></>}
                              {__product.item_tab === 'modifiers' ? <ProductModifiers /> : <></>}
                              {__product.item_tab === 'with' ? <ProductWith /> : <></>}
                              {__product.item_tab === 'marketing' ? <ProductMarketing /> : <></>}
                              {__product.item_tab === 'files' ? <ProductFiles /> : <></>}
                              {__product.item_tab === 'set' ? <ProductSet /> : <></>}
                              {__product.item_tab === 'price' ? <ProductPrice /> : <></>}
                              {__product.item_tab === 'links' ? <ProductLinksToProducts /> : <></>}
                              {__product.item_tab === 'split_payments' ? <ProductSplitPayments /> : <></>}
                            </fieldset>
                        }
                      </Col>
                    </>
                    : <></>
                  }

                </Row>
            </form>
        </>
    )
})